import React from 'react'

const AccountInfo = ({ formData, handleInputChange, isEditMode = false }) => {
  return (
    <div className="col-sm-12 col-lg-3">
      <fieldset>
        <legend>Account Information</legend>
        {!isEditMode && (
          <>
            <div className="floating-label-wrap">
              <label htmlFor="username" className="floating-label">
                Username<span className="mandatory">*</span>
              </label>
              <input
                id="username"
                name="username"
                className="longBox floating-label-field floating-label-field--s3"
                type="text"
                value={formData.username}
                onChange={handleInputChange}
                maxLength={30}
                autoComplete="off"
              />
            </div>
            <div className="floating-label-wrap">
              <label className="floating-label" htmlFor="password">
                Password<span className="mandatory">*</span>
              </label>
              <input
                id="password"
                name="password"
                className="longBox floating-label-field floating-label-field--s3"
                type="password"
                value={formData.password}
                onChange={handleInputChange}
                maxLength={30}
                autoComplete="new-password"
              />
            </div>
            <div className="floating-label-wrap">
              <label className="floating-label" htmlFor="confirmPassword">
                Confirm Password<span className="mandatory">*</span>
              </label>
              <input
                id="confirmPassword"
                name="confirmPassword"
                className="longBox floating-label-field floating-label-field--s3"
                type="password"
                value={formData.confirmPassword}
                onChange={handleInputChange}
                maxLength={30}
              />
            </div>
            <div className="floating-label-wrap">
              <label className="floating-label" htmlFor="passwordHint">
                Password Hint<span className="mandatory">*</span>
              </label>
              <input
                id="password_hint"
                name="password_hint"
                className="longBox floating-label-field floating-label-field--s3"
                type="text"
                value={formData.password_hint}
                onChange={handleInputChange}
                maxLength={30}
              />
            </div>
          </>
        )}
        <div className="floating-label-wrap">
          <label className="floating-label" htmlFor="email">
            Email<span className="mandatory">*</span>
          </label>
          <input
            id="email"
            name="email"
            className="longBox floating-label-field floating-label-field--s3"
            type="text"
            value={formData.email}
            onChange={handleInputChange}
            maxLength={30}
          />
        </div>
        <div className="styled-input">
          <label htmlFor="player_level">Player Level <span className="mandatory">*</span> </label>
          <select id="player_level" name="player_level" className="preferredPhone" value={formData.player_level} onChange={handleInputChange}>
            <option value="" disabled>Please Select</option>
            <option value="3.0">3.0</option>
            <option value="3.5">3.5</option> 
            <option value="4.0">4.0</option>
            <option value="4.5">4.5</option>
            <option value="5.0">5.0</option>
          </select>
        </div>
        <div className="styled-input">
          <label htmlFor="ratedBy">Rated By</label>
          <select id="ratedby" name="ratedby" className="preferredPhone" value={formData.ratedby} onChange={handleInputChange}>
            <option value="" disabled>Please Select</option>
            <option value="USTA Rated">USTA Rated</option>
            <option value="Self">Self Rated</option>
          </select>
        </div>
        <div className="clear" />
      </fieldset>
    </div>
  )
}

export default AccountInfo